import SearchComponent from './search-component';
import FacetFilters from '../product/facet-filters';

export default class FacetSearchComponent extends SearchComponent {
  private readonly facetFilters;

  constructor(container: HTMLElement) {
    super(container);
    this.facetFilters = new FacetFilters($(container));
  }
}
